/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategorySearchItemModelSearchResultModel } from '../../models/category-search-item-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface CategorySearchCategoryPost$Plain$Params {
      body?: SearchRequestModel
}

export function categorySearchCategoryPost$Plain(http: HttpClient, rootUrl: string, params?: CategorySearchCategoryPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<CategorySearchItemModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, categorySearchCategoryPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<CategorySearchItemModelSearchResultModel>;
    })
  );
}

categorySearchCategoryPost$Plain.PATH = '/Category/SearchCategory';
